<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <span></span>
      </template>
    </app-breadcrumb>
    <div class="card">
      <div class="card-body p-1">
        <div class="row">
          <div class="col-12 col-md-3">
            <b-form-group label="Kênh"
              class="mb-0">
              <v-select v-model="channel_id"
                :options=dataChannel
                label="name"
                :reduce="(val) => val.id"
                placeholder="--Chọn--" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Đến ngày"
              class="mb-0">
              <flat-pickr v-model="start_date"
                class="form-control"
                :config="config_time"
                placeholder="yyyy-mm-dd" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <b-form-group label="Đến ngày">
              <flat-pickr v-model="end_date"
                class="form-control"
                :config="config_time"
                placeholder="yyyy-mm-dd" />
            </b-form-group>
          </div>
          <div class="col-12 col-md-3">
            <div style="margin-top: 2rem;">
              <b-button variant="danger"
                @click="updateSearchQuery">
                <feather-icon icon="SearchIcon" /> tìm kiếm </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <b-card no-body
        class="mb-0">
        <b-table ref="refRoleListTable"
          class="position-relative"
          :items="itemsData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="Không tìm thấy kết quả">
          <template #cell(name)="data">
            <router-link :to="{ name: 'schedule-edit', params: { id: data.item.id } }"> {{ data.item.name }} </router-link>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button size="sm"
              class=""
              variant="outline-primary"
              :to="{ name: 'schedule-edit', params: { id: data.item.id } }">
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button size="sm"
              class="ms-2"
              variant="outline-danger"
              @click="onDestroy(data.item)">
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon"
                    size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon"
                    size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>

import { ref, watch, computed } from '@vue/composition-api';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import { showToast } from '@core/utils/utils';
import {
  BOverlay, BCard, BRow, BCol, BFormInput, BTable,
  BBadge, BPagination, BForm, BFormGroup, BButton
} from 'bootstrap-vue'
import store from '@/store';
import vSelect from 'vue-select'
export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    AppBreadcrumb,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
    flatPickr
  },
  setup() {
    const refRoleListTable = ref(null);
    const tableColumns = [
      { key: 'id', label: 'ID', thAttr: { width: '6%' }, thClass: 'text-center', tdClass: 'text-center' },
      { key: 'name', label: 'Tiêu đề' },
      { key: 'channel_id', label: 'Kênh', thAttr: { width: '15%' } },
      { key: 'type', label: 'Loại', thAttr: { width: '10%' } },
      { key: 'date_play', label: 'Ngày phát', thAttr: { width: '10%' } },
      { key: 'actions', label: 'Hành động', thAttr: { width: '10%' }, class: 'action', },
    ];

    const loading = ref(false);
    const perPage = ref(30);
    const totalEntries = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 30, 50, 100];
    const searchQuery = ref('');
    const channel_id = ref('');
    const end_date = ref();
    const start_date = ref();
    const isPaginate = ref(1);
    const itemsData = ref([]);
    const dataChannel = ref([])

    const dataMeta = computed(() => {
      const localItemsCount = refRoleListTable.value ? refRoleListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalEntries.value,
      };
    });

    const fetchAll = () => {
      loading.value = true;
      store
        .dispatch('schedule/fetchAll', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          isPaginate: isPaginate.value,
          channel_id: channel_id.value,
          start_date: start_date.value,
          end_date: end_date.value
        })
        .then((response) => {
          loading.value = false;
          let result = response.data;
          if (result.code === 200) {
            const items = result.data.data;
            totalEntries.value = result.data.total;
            itemsData.value = items;
            dataChannel.value = result.data.config.channel;
          }
        });
    };

    const refetchData = () => {
      fetchAll();
    };

    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });
    const updateSearchQuery = () => {

      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hớn từ ngày');
        return false;
      }
      refetchData()
    };

    fetchAll();
    const config_time = ref({
      dateFormat: 'Y-m-d',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      channel_id,
      itemsData,
      refetchData,
      dataChannel,
      start_date,
      end_date,
      config_time,
      updateSearchQuery
    }
  },
  methods: {
    onDestroy(item) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa lịch phát sóng này không?',

        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const { id } = item
          store.dispatch('schedule/destroy', { id })
            .then(response => {
              const result = response.data
              let msg_class = '';
              if (result.code === 200) {
                msg_class = 'success';
                this.refetchData()
              }
              showToast(result.message, { variant: msg_class })
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
